import { atom } from "recoil";

const initialState = {
    isGuest: localStorage.getItem("tokenUser") !== null ? false : true,
    isAuthenticated: localStorage.getItem("tokenUser") !== null ? true : false,
    payload: null
};

export const userState = atom({
    key: 'userState',
    default: initialState,
    effects_UNSTABLE: [
        ({ onSet }) => {
            onSet(newValue => {
                console.log("userState 111 => ", newValue);
            })
        }
    ]
});